import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MessageTemplatesApi } from 'api/MessageTemplatesApi';
import { MESSAGE_TEMPLATES_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function usePublishMessageTemplate() {
  const messageTemplatesApi = new MessageTemplatesApi();
  const { userBankId } = useUser();
  const queryClient = useQueryClient();

  const { mutateAsync: publishMessageTemplate, isPending: isPublishingMessageTemplate } = useMutation({
    mutationKey: [MESSAGE_TEMPLATES_KEY, 'publish'],
    mutationFn: (id: string) => messageTemplatesApi.publishMessageTemplate(userBankId, id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MESSAGE_TEMPLATES_KEY, userBankId] });
    },
    meta: {
      snackbarSuccessMessage: 'Template published.',
      snackbarErrorMessage: 'There was an issue publishing the template. Please contact support.'
    }
  });

  return { publishMessageTemplate, isPublishingMessageTemplate };
}
